import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {navigateToLinkAction} from '../../store/stateless/navigationActions';
import {SettingsSignaturesList} from './settingsSignaturesList';

const mapStateToProps = makeMapStateToProps()(() => ({}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  navigateToLink: navigateToLinkAction,
}));

export const SettingsSignaturesListContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsSignaturesList);
